export const COST_CENTER_CONTABILITY = 'AF-CONT';